// Basic guitar tabs for every publicly released WOLF song.
// To add a tab: set `tab` to a string (chords + optional 6-line tab). null = "Tab coming soon".
// Optional: `tuning`, `capo`, `key`.
const song = (title, extra = {}) => ({ title, tab: null, ...extra });

export const TAB_GROUPS = [
  {
    release: "Godwolf",
    cover: "/godwolf-cover.jpg",
    songs: [song("Glory Be")],
  },
  {
    release: "Peace With Teeth",
    cover: "/peace-with-teeth-cover.jpg",
    songs: [
      "Peace With Teeth", "Carved Inside My Mind", "Just Like You", "Inevitable Addiction",
      "Cocaine Wolf", "Clarity Cuts Through the Haze", "Ancestral Bloodline", "FUCK THE NOISE",
      "Line and Sinker", "I Am Your Destiny", "Jesus Is King", "Unfiltered",
      "Seven Still Stand", "My Mona Lisa", "Bleed For The Cause", "Michael and Me",
      "I Went Intergalactic", "Heaven Is a Merry-Go-Round", "Northbound Dreams", "Angels Beside",
      "Holy Guidance", "Let the Wolf Rest", "In God's Hands", "Grace Got Loud",
      "Monster", "Heaven Got Juice", "Calm as a Wolf in His", "The Wolf Came Home",
      "Where I Get My Strength From", "I Never Left", "Gladly", "You're the Only One",
      "Guard Up, Heart Open", "Another Chapter Starts", "Complete Surrender", "A Day in the Life of",
      "Chinese Wolf", "Back in Love", "Come and Get It",
    ].map((t) => song(t)),
  },
  {
    release: "No More Fear",
    cover: "/no-more-fear-cover.jpg",
    songs: [song("No More Fear")],
  },
  {
    release: "Reborn",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/ixucow66_D15A2D70-A49B-4B34-B2A1-0D7BFAD5A4BA.png",
    songs: [song("Resurrected"), song("Unbreakable"), song("Still Waiting On You")],
  },
  {
    release: "Singles",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/7qmv91n7_byron%20air%20cover%20art.jpg",
    songs: [song("Byron Air"), song("Yukon Wheels"), song("For You"), song("Legend")],
  },
  {
    release: "Wolf",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/pbp5yabt_IMG_2649.jpeg",
    songs: [song("Wolf")],
  },
];

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
